import { Action, combineReducers, configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk, { ThunkDispatch } from 'redux-thunk';
import {userVerificationReducer} from "./redux/UserVerificationRedux";
import {otpConfirmReducer} from "./redux/OTPConfirmRedux";
import {accountListReducer} from "./redux/UserAccountListRedux";
import {regAccountReducer} from "./redux/RegAccountListRedux";
import {deviceReducer} from "./redux/DeviceRedux";
import { billerReducer } from "./redux/BillerRedux";
import { userInfoReducer } from './redux/UserInfoRedux';

const appReducer = combineReducers({
    userInfoReducer,
    userVerificationReducer,
    otpConfirmReducer,
    accountListReducer,
    regAccountReducer,
    deviceReducer,
    billerReducer
});

const rootReducer = (state: RootState | undefined, action: Action) => {
  return appReducer(action.type === 'LOGOUT' ? undefined : state, action);
};

const persistedReducer = persistReducer(
  {
    key: 'rootReducer',
    storage,
    whitelist: ['billerReducer']
    // whitelist: ['authentication', 'taskList', 'taskDetail', 'documentUpload'],
  },
  rootReducer,
);

const middleWares = [thunk, logger];


const checkEnv = (env: string): boolean => {
   const devEnv = ['DIT', 'SIT', 'DIT2', 'UAT'];
   return devEnv.includes(env);
};

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware: any) => getDefaultMiddleware().concat(middleWares),
  devTools: checkEnv((window as any).chaiyoGlobalConfig.env),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof appReducer>;

export type DispatchType<T = RootState> = ThunkDispatch<T, never, Action>;
